import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Edit, RefreshCw, Users, AlertTriangle } from 'lucide-react';
import { Permission } from '@/services/rolesPermissionsService';
import { getPermissionDisplayName, getPermissionDescription } from '@/auth/permissions';

interface PermissionCardProps {
  permission: Permission;
  onEdit: (permission: Permission) => void;
  onManageRoles: (permission: Permission) => void;
}

export const PermissionCard: React.FC<PermissionCardProps> = ({
  permission,
  onEdit,
  onManageRoles
}) => {
  return (
    <Card className="border-l-4 border-l-blue-500">
      <CardHeader>
        <div className="flex justify-between items-start gap-2">
          <div className="min-w-0 flex-1">
            <CardTitle className="text-lg break-words">
              {permission.display_name || getPermissionDisplayName(permission.name)}
            </CardTitle>
            {(permission.display_name || getPermissionDisplayName(permission.name) !== permission.name) && (
              <p className="text-xs text-muted-foreground font-mono mt-1 break-all">
                {permission.name}
              </p>
            )}
          </div>
          <div className="flex shrink-0 gap-1">
            <Button
              size="icon"
              variant="ghost"
              onClick={() => onManageRoles(permission)}
              title="Gestionar roles"
            >
              <RefreshCw className="w-4 h-4" />
            </Button>
            <Button
              size="icon"
              variant="ghost"
              onClick={() => onEdit(permission)}
              title="Editar permiso"
            >
              <Edit className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-3">
          {permission.description || getPermissionDescription(permission.name) || 'Sin descripción'}
        </p>
        <div className="flex items-center gap-2 text-sm">
          {(!permission.roles || permission.roles.length === 0) ? (
            <>
              <AlertTriangle className="w-4 h-4 text-amber-500" />
              <span className="text-muted-foreground">Sin roles asignados</span>
            </>
          ) : (
            <>
              <Users className="w-4 h-4 text-green-500" />
              <span className="font-medium">
                {permission.roles.length}
                {permission.roles.length === 1 ? ' rol asignado' : ' roles asignados'}
              </span>
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
};